<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 16C12 17.1046 11.1046 18 10 18C8.89543 18 8 17.1046 8 16M12 16C12 14.8954 11.1046 14 10 14C8.89543 14 8 14.8954 8 16M12 16H20M8 16L4 16M16 8C16 9.10457 15.1046 10 14 10C12.8954 10 12 9.10457 12 8M16 8C16 6.89543 15.1046 6 14 6C12.8954 6 12 6.89543 12 8M16 8H20M12 8H4"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
